import styles from './Ellipsis.module.css';

type IntrinsicDivProps = JSX.IntrinsicElements['div'];

/**
 * Add an Ellipsis to content to handle overflow text.
 *
 * @deprecated Use `text-overflow: ellipsis;` in the CSS
 * @see https://corgi-x.tfd.engineering/components/ellipsis
 */
export function Ellipsis({ children, ...props }: IntrinsicDivProps) {
  return (
    <span className={styles.ellipsis} {...props}>
      {children}
    </span>
  );
}
